import { getAccessToken } from './auth/msal';
import { config } from './config';

export type FormioSchema = Record<string, unknown>;

export interface FormVersion {
  id: string;
  versionNumber: number;
  state: 'Draft' | 'Published';
  schema: FormioSchema;
}

export interface FormDetail {
  id: string;
  title: string;
  publishedVersionId: string | null;
  draft: FormVersion | null;
  published: FormVersion | null;
}

async function request<T>(path: string, method: string, body?: unknown): Promise<T> {
  const token = await getAccessToken();
  const response = await fetch(`${config.apiBaseUrl}${path}`, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(body !== undefined ? { 'Content-Type': 'application/json' } : {}),
    },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}: ${await response.text()}`);
  }
  return (await response.json()) as T;
}

export const api = {
  getForm: (id: string) => request<FormDetail>(`/api/forms/${id}`, 'GET'),
  saveDraftSchema: (id: string, schema: FormioSchema) =>
    request<FormDetail>(`/api/forms/${id}/draft`, 'PUT', { schema }),
};
